import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function WhatIsMapleOS() {
  const page = getSemanticPageByPath('/what-is-mapleos');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
